<template>
  <div class="content">
    <div class="card">
      <Card :class="{ blurred: !isLogin}" v-for="(item, index) in monList" :key="item" :title="item" :date="`${year}-${index + 1}-01`" :list="list"></Card>
    </div>
  </div>
</template>

<script>
import Card from '@/views/WorkFlow/card.vue'
import { calendarList } from './config'
export default {
  props: ['isLogin'],
  data() {
    return {
      year: '2024',
      monList: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      list: calendarList
    }
  },
  components: {
    Card
  }
}
</script>

<style lang="scss" scoped>
.content{
  margin: 0 auto;
}
.card{
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}
.blurred{
  filter: blur(2px);
}
</style>



// WEBPACK FOOTER //
// src/views/gcplog/calendar.vue